export default "/WebApp/dist/assets/fonts/Raleway-Regular.ttf";